module.exports = __webpack_public_path__ + "static/media/Banner-Ortho-mobile.45ab8c85.png";